import { render, staticRenderFns } from "./SelectSemester.vue?vue&type=template&id=c8ddfe9a&scoped=true"
import script from "./SelectSemester.vue?vue&type=script&lang=js"
export * from "./SelectSemester.vue?vue&type=script&lang=js"
import style0 from "./SelectSemester.vue?vue&type=style&index=0&id=c8ddfe9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ddfe9a",
  null
  
)

export default component.exports